import {db} from "@/db";
import {utils} from "@/utils/utils";

const sp = require("swiss-pairing")({maxPointsPerRound: 1})

export const teams = {
    updateTeam(store, team) {
        return db.collection(`events/${store.state.event.id}/teams`)
            .doc(team.id)
            .set(team)
            .then(() => {
                console.log('teams set!')
            })
    },
    uniqueClassNames() {
        const ret = [];
        this.$store.state.teams.forEach((team) => {
            if (team.className && ret.indexOf(team.className < 0)) {
                ret.push(team.className);
            }
        });
        return ret;
    },

    updateStandings: function (store, round) {
        const participants = utils.getParticipants(store,round.number);
        const results = utils.getResults(store);

        const standings = sp.getStandings(round.number+1, participants, results);
        let placing =1;
        standings.forEach((standing) => {
            const team = store.state.teams.find(team => team.id === standing.id);
            if (team) {
                if(standing.seed){
                    team.seed = standing.seed;
                }
                team.wins = standing.wins;
                team.losses = standing.losses;
                team.tiebreaker = standing.tiebreaker;
                team.place = placing;
                placing++;
                this.updateTeam(store, team).then();
            }
        });

    },
}


